import { APIClient } from "../../../helpers/api_helper";
import { recieveWizardAlerts, removeWizardAlertLocal } from "./reducer";

const api = new APIClient();
const URL = "/api/wizard_alerts/";

export const loadWizardAlerts = () => async (dispatch) => {
  try {
    const data = await api.get(URL);
    // A 403 resolves to null (see the api_helper response interceptor).
    dispatch(recieveWizardAlerts(Array.isArray(data) ? data : []));
  } catch (error) {
    console.error("Unable to load repeat warnings!", error);
  }
};

export const ackWizardAlert = (wizardId) => async (dispatch) => {
  dispatch(removeWizardAlertLocal(wizardId));
  try {
    // successMsg: null -- the response interceptor toasts "Uspešno shranjeno!"
    // whenever `meta` is present, and dismissing a hint is not a save.
    await api.create(`${URL}${wizardId}/ack/`, {}, { successMsg: null });
  } catch (error) {
    console.error("Unable to acknowledge repeat warning!", error);
    // Put it back: the warning is the whole point, so failing quietly is worse
    // than showing it again.
    dispatch(loadWizardAlerts());
  }
};
